import { Col, Container, Row } from "reactstrap";
import { BonusUi, TreeViewTitle } from "../../../constants";
import BasicTrees from "./BasicTrees";
import DisabledTree from "./DisabledTree";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const TreeViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TreeViewTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <Col md="6">
            <BasicTrees />
          </Col>
          <Col md="6">
            <DisabledTree />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default TreeViewContainer;
